import React from "react";

const Spinner = () => {
  return (
    <>
      <div className="preloader">
        <div className="spinner"></div>
      </div>
    </>
  );
};

export default Spinner;
